<template>
  <page>
    <div>
      <!-- Add Filters here -->
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex md6>
                          <v-autocomplete
                            :items="riskNo"
                            v-model="filters.riskNo"
                            :label="label.riskNo"
                            item-text="label"
                            item-value="value"
                            data-vv-name="riskNo"
                            :data-vv-as="label.riskNo"
                            :error-messages="errors.collect('riskNo')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex md6>
                          <v-autocomplete
                            :items="defBusCls"
                            v-model="filters.defBusCls"
                            :label="label.defBusCls"
                            item-text="label"
                            item-value="value"
                            data-vv-name="defBusCls"
                            :data-vv-as="label.defBusCls"
                            :error-messages="errors.collect('defBusCls')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-1"></v-spacer>
      <v-card>
        <v-card-title>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ label.scheme }}</v-subheader>
                <div class="queryValue">{{ incomingScheme }} - {{ incomingSchemeDesc }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ label.polType }}</v-subheader>
                <div class="queryValue">{{ incomingPolType }} - {{ incomingPolTypeDesc }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ label.planNo }}</v-subheader>
                <div class="queryValue">{{ incomingPlanNo }} - {{ receivedPlanDesc }}</div>
              </v-flex>
              <v-spacer></v-spacer>
              <v-btn color="primary" dark class=" mr-2" @click="doUpload">
                Package Standard Text
                <v-icon right>mdi-upload</v-icon>
              </v-btn>
              <v-btn color="primary" dark class=" mr-2" @click="doNew">
                New Risk
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
            </v-layout>
          </v-container>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              :server-items-length="totalItems"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.riskNo }}</td>
                  <td class="text-xs-left">{{ row.item.defBusCls }}</td>
                  <td class="text-xs-left">{{ row.item.defTariff }}</td>
                  <td class="text-xs-left">{{ row.item.defStdRiskTxtRef }}</td>
                  <td class="text-xs-left">{{ row.item.perMaxItemNo }}</td>
                  <td class="text-xs-left">{{ row.item.perMaxBeneNo }}</td>
                  <td class="table-action-header">
                    <table-action :rowData="row" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                  </td></tr
              ></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doDelete">
        <p>Please confirm deletion of this records.</p>
        <div class="queryValue">
          Scheme: {{ selectedPkgRisk.scheme }}<br />
          Plan No.: {{ selectedPkgRisk.planNo }}<br />
          Risk No.: {{ selectedPkgRisk.riskNo }}
        </div>
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
import { packageDataMixin } from '@/mixins/params/packageDataMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      toogleArray: [false],
      loading: false,
      scheme: [],
      riskNo: [],
      defBusCls: [],
      headers: [
        { text: 'Risk No.', value: 'riskNo' },
        { text: 'Default Business Class', value: 'defBusCls' },
        { text: 'Default Tariff', value: 'defTariff' },
        { text: 'Default Standard Risk Text', value: 'defStdRiskTxtRef' },
        { text: 'Max No. of Item(s)', value: 'perMaxItemNo' },
        { text: 'Max No. of Benefit(s)', value: 'perMaxBeneNo' },
        TableConst.tableActionHeader
      ],
      label: {
        riskNo: 'Risk No.',
        defBusCls: 'Default Business Class',
        scheme: 'Scheme',
        planNo: 'Plan No.',
        polType: 'Policy Type'
      },
      filters: {
        scheme: undefined,
        planNo: undefined,
        riskNo: undefined,
        defBusCls: undefined
      },
      totalItems: 0,
      promptRemove: false,
      selectedPkgRisk: {
        scheme: undefined,
        planNo: undefined,
        riskNo: undefined
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  async mounted() {
    await this.$store.dispatch('packagePlanInit')
    this.fetchData(true)
    this.doInit()
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataList('riskNo')
      this.getCommonDataList('defBusCls')
      this.fetchData(true)
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.packageRiskList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  riskNo: datamap.riskNo,
                  defBusCls: datamap.defBusCls,
                  defTariff: datamap.defTariff,
                  defStdRiskTxtRef: datamap.defStdRiskTxtRef,
                  perMaxItemNo: datamap.perMaxItemNo,
                  perMaxBeneNo: datamap.perMaxBeneNo
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doNew() {
      const commit = {
        tranMode: 'newMode',
        scheme: this.pkgPlanId.scheme,
        planNo: this.pkgPlanId.planNo,
        riskNo: undefined,
        defBusCls: undefined,
        defTariff: undefined,
        defStdRiskTxtRef: undefined,
        perMaxItemNo: undefined,
        perMaxBeneNo: undefined,
        defClse1: undefined,
        defClse2: undefined,
        defClse3: undefined,
        defClse4: undefined,
        defClse5: undefined,
        allowClmBefCvr: false
      }
      sessionStorage.setItem('pkgRisk', JSON.stringify(commit))
      this.$store.commit('PACKAGERISK_COMMIT_KEY', commit)
      this.$router.push({ name: 'pkgRiskReview' })
    },
    doReview(data) {
      const commit = {
        tranMode: 'reviewMode',
        scheme: this.pkgPlanId.scheme,
        planNo: this.pkgPlanId.planNo,
        riskNo: data.riskNo,
        defBusCls: data.defBusCls,
        defTariff: data.defTariff,
        defStdRiskTxtRef: data.defStdRiskTxtRef,
        perMaxItemNo: data.perMaxItemNo,
        perMaxBeneNo: data.perMaxBeneNo,
        defClse1: data.defClse1,
        defClse2: data.defClse2,
        defClse3: data.defClse3,
        defClse4: data.defClse4,
        defClse5: data.defClse5,
        allowClmBefCvr: data.allowClmBefCvr,
        schemeDesc: this.incomingSchemeDesc,
        polTypeDesc: this.incomingPolTypeDesc
      }
      sessionStorage.setItem('pkgRisk', JSON.stringify(commit))
      this.$store.commit('PACKAGERISK_COMMIT_KEY', commit)
      this.$router.push({ name: 'pkgRiskReview', params: { incomingRiskNo: data.riskNo } })
    },
    doPromptRemove(data) {
      if (data) {
        this.selectedPkgRisk.scheme = this.incomingScheme
        this.selectedPkgRisk.planNo = this.incomingPlanNo
        this.selectedPkgRisk.riskNo = data.riskNo
        this.promptRemove = true
      }
    },
    async doDelete() {
      this.resetMessages()
      if (this.selectedPkgRisk && this.selectedPkgRisk.scheme && this.selectedPkgRisk.planNo && this.selectedPkgRisk.riskNo) {
        const apiURI = this.menu.deletePkgRisk
        if (apiURI) {
          const expand = {
            scheme: this.selectedPkgRisk.scheme,
            planNo: this.selectedPkgRisk.planNo,
            riskNo: this.selectedPkgRisk.riskNo
          }
          this.$http
            .post(apiURI, expand)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.fetchData(false)
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    async doUpload() {
      this.resetMessages()
      const apiURI = this.menu.uploadPkgStdTxt1
      if (apiURI) {
        this.loading = true
        this.$toast.success('Uploading now. Please Wait.')
        this.$http
          .post(apiURI)
          .then((result) => {
            const data = result.data
            if (data) {
              this.notify(data)
              const apiURI = this.menu.uploadPkgStdTxt2
              if (apiURI) {
                this.$http.post(apiURI).then((result) => {
                  const data = result.data
                  if (data) {
                    this.notify(data)
                    const apiURI = this.menu.uploadPkgStdTxt3
                    if (apiURI) {
                      this.$http.post(apiURI).then((result) => {
                        const data = result.data
                        this.notify(data)
                        this.$toast.success('Uploaded Successfully!')
                        this.fetchData(false)
                        this.loading = false
                      })
                    }
                  }
                })
              }
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.loading = false
            }
          })
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.riskNo = undefined
      this.filters.defBusCls = undefined
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    }
  },
  computed: {
    menu() {
      return this.$store.state.pkgParam.pkgPlan.menu
    },
    receivedScheme() {
      return this.$route.params.incomingScheme
    },
    receivedPlanNo() {
      return this.$route.params.incomingPlanNo
    },
    receivedPolType() {
      return this.$route.params.incomingPolType
    },
    receivedPlanDesc() {
      return this.$store.state.pkgParam.pkgPlan.pkgPlanId.planDesc
    },
    pkgPlanId() {
      return this.$store.state.pkgParam.pkgPlan.pkgPlanId
    }
  },
  created() {
    if (this.receivedScheme !== 'noScheme' && this.receivedPlanNo !== 'noPlanNo') {
      this.filters.scheme = this.receivedScheme
      this.filters.planNo = this.receivedPlanNo
    } else {
      this.filters.scheme = undefined
      this.filters.planNo = undefined
    }
  },
  props: ['incomingScheme', 'incomingPlanNo', 'incomingPolType', 'incomingPlanDesc', 'incomingSchemeDesc', 'incomingPolTypeDesc'],
  mixins: [TableConst.default, packageDataMixin, commonAjaxMixin, MessageMixin]
}
</script>
